
import Blog from "../component/blogs"

function Blogs(){
    return(
        <>
        <Blog/>
        </>
    )
}
export default Blogs